
import AutoCompleteInput from '../common/AutoCompleteInput';
import FloatingLabelInput from '../common/FloatingLabelInput';
import VerificationCodeInput from '../common/VerificationCodeInput';
import PhoneNumberInput from '../common/PhoneNumberInput';
import NeedMoblieNumberPopover  from '../need_mobile_number_popover/NeedMoblieNumberPopover';
import SignUpSuccessModal from '../idc_signup_success_modal/SignUpSuccessModal';


const { text, routes, url, Logger } = window;
const { _ } = window;

export default class SignIn extends Backbone.View {
    constructor(el, ozoneData, forwardUrl, formKey = '', errorMessage = '', captchaRequired = false, showIdcSignUp = false) {
        super(...arguments);
        this.el = el;
        this.ozoneData = ozoneData;
        this.forms = ozoneData.forms;
        this.features = ozoneData.features;
        this.forwardUrl = forwardUrl;
        this.formKey = formKey || window.Cookies.get('ozonePreferedIls');
        this.errorMessage = errorMessage;
        this.captcha = !!captchaRequired && ozoneData.captcha;
        this.showIdcSignUp = showIdcSignUp === 'true';
        this.idcOptions = ozoneData.getACard;
    }

    _render() {
        if (this.showIdcSignUp && this.ozoneData.getACard) {
            this.showIdcSignUp = false;
            this._renderIdcSignup();
        }else{
            this.el.empty().append(this._mainFormHtml());
            this.inputContainer = this.el.find('.inputContainer');
            this.bottomSignInOptionsDiv = this.el.find('.bottomSignInOptionsContainer');
            this._renderLibraryCardForm();
        }
    }

    _mainFormHtml() {
        return `
            <h1 class="headerText primary-color">${text("signInPage.welcome")}</h1>
            <p class="pleaseSignIn">${text("signInPage.pleaseSignIn")}</p>
            ${this.ozoneData.getACard && this.ozoneData.getACard.primary.signUp ? `
                <div class="getACardPromo">
                    <p>${text('signInPage.memberYet')} <a class="secondary-color getOneInstantly" tabindex="0">${text('signInPage.getACard')}</a></p>
                </div>
            ` : ''}
            <div class="inputContainer"></div>
            <div class="bottomSignInOptionsContainer"></div>
        `;
    }

    _renderLibraryCardForm() {
        this.inputContainer.empty();
        let libraryCardSignInContaniner = $('<div class="LibraryCardSignIn"></div>');

        let selectedForm;
        if (this.formKey) {
            selectedForm = this.forms.find((f) => f.ilsName === this.formKey);
            this._renderSubForm(selectedForm, libraryCardSignInContaniner);
        }

        if (this.forms.length === 1) {
            this._renderSubForm(this.forms[0], libraryCardSignInContaniner);
        }
        else {
            new AutoCompleteInput({
                el: this.inputContainer,
                className: 'signInInput',
                id: 'signin-options',
                label: text('signInPage.libraryCard.branches'),
                fieldList: this.forms.map((f) => f.displayName),
                defaultField: selectedForm && selectedForm.displayName,
                selectedEvent: ((branchKey) => {
                    selectedForm = this.forms.find((f) => f.displayName === branchKey);

                    const millisecondsInYear = 1000 * 60 * 60 * 24 * 365;
                    const expireDate = new Date(Date.now() + millisecondsInYear);
                    window.Cookies.set('ozonePreferedIls', selectedForm.ilsName, {httpOnly: false, expires: expireDate});

                    this._renderSubForm(selectedForm, libraryCardSignInContaniner);
                })
            }).render();
        }

        this.inputContainer.append(libraryCardSignInContaniner);

        if (this.errorMessage) {
            this._showErrorMessage(this.errorMessage);
        }

        if (this.ozoneData.getACard) {
            this._addSecondarySignIn('mobileNumber');
        }

        this._updateGetOneInstantlyButton(true);
        this.el.focus();
    }

    _renderSubForm(selectedForm, container) {
        container.empty();

        let inputs;
        if (selectedForm.type === 'External') {
            inputs = $(`
                <div class="ExternalSignInTextContainer">
                    <p>${text('signInPage.libraryCard.externalSignIn')}</p>
                </div>
            `);
        } else if (selectedForm.type === 'EmailRegistration') {
            this._renderEmailRegistration(selectedForm, container);
            return;
        } else {
            inputs = $('<div></div>');
            if (selectedForm.local.username.enabled) {
                inputs.append(`
                    <div class="usernameContainer"></div>
                    ${!!selectedForm.loginHintUrl ? `
                        <div class="helpLinkContainer">
                            <a class="helpLink" href="${selectedForm.loginHintUrl}" target="_blank">
                                ${text('signInPage.helpLink', {fieldName: text(`signInPage.usernameKeys.${selectedForm.local.username.key || 'CardNumber'}`)})}
                            </a>
                        </div>
                    ` : ''}
                `);
            }

            if (selectedForm.local.password.enabled) {
                inputs.append(`
                    <div class="passwordContainer"></div>
                    ${!!selectedForm.pinHelpUrl ? `
                        <div class="helpLinkContainer">
                            <a class="helpLink" href="${selectedForm.pinHelpUrl}" target="_blank">
                                ${text('signInPage.helpLink', {fieldName: text(`signInPage.usernameKeys.${selectedForm.local.password.key || 'PIN'}`)})}
                            </a>
                        </div>
                    ` : ''}
                `);
            }
        }

        let template = $(`
            <form name="login-form" id="login-form" method="post" action="${window.url(routes.ozone.authenticate, {forwardUrl: this.forwardUrl})}">
                <input type="hidden" name="ilsName" value="${selectedForm.ilsName}">
                <input type="hidden" name="authType" value="${selectedForm.type}">
                ${inputs.html()}
                ${this.captcha ? `
                    <div class="g-recaptcha" data-sitekey="${this.captcha.key}"></div>
                ` : ''}
                <div class="buttonsContainer">
                    <button class="signin-button button secondary">
                        <span>${text('signIn')}</span>
                    </button>
                </div>
            </form>
        `);

        container.append(template);

        this.username = undefined;
        this.password = undefined;
        if (selectedForm.type === 'Local' && selectedForm.local.username.enabled) {
            this.username = new FloatingLabelInput({
                el: template.find('.usernameContainer'),
                className: 'signInInput',
                id: 'username',
                // replace spaces with non-breaking spaces to prevent Safari from interpreting the "card number" field as a credit card input
                label: text(`signInPage.usernameKeys.${selectedForm.local.username.key || 'CardNumber'}`).replace('\x20', '\xa0'),
                autocompleteHint: window.featureManager.isEnabled('ozoneAutocompleteHint') ? 'username' : null
            }).render();
        }

        if (selectedForm.type === 'Local' && selectedForm.local.password.enabled) {
            this.password = new FloatingLabelInput({
                el: template.find('.passwordContainer'),
                className: 'signInInput',
                id: 'password',
                label: text(`signInPage.pinKeys.${selectedForm.local.password.key || 'PIN'}`),
                type: 'password',
                autocompleteHint: window.featureManager.isEnabled('ozoneAutocompleteHint') ? 'current-password' : null
            }).render();
        }

        template.find('.signInInput input').on('keypress', (e) => {
            if (e.which === 13) {
                e.preventDefault();
                this._submit();
            }
        });

        template.find(".signin-button").on('click', (e) => {
            e.preventDefault();
            if(selectedForm.type === 'External'){
                window.globalEvents.trigger('signIn:external', selectedForm.displayName);
            }else{
                window.globalEvents.trigger('signIn:library', selectedForm.displayName);
            }

            this._submit();
        });
    }

    _submit(){
        let validUsername = !this.username || this.username.validateNonEmpty();
        let validPassword = !this.password || this.password.validateNonEmpty();

        if (validUsername && validPassword) {
            this.el.find(".signin-button").empty().addClass('waiting').append('<div class="spinner"></div>');
            this.el.find('#login-form').submit();
        }
    }

    _renderMobileNumberForm() {
        this.inputContainer.empty();
        this.el.find('.errorMessage').remove();

        let template = $(`
            <div class="MobileSignIn">
                <div class="mobileNumberContainer"></div>
                <div class="verificationCodeText">
                    <p>${text('signInPage.mobile.textVerificationCode')}</p>
                    <p>${text('signInPage.mobile.ratesMayApply')}</p>
                </div>
                <div class="buttonsContainer">
                    <button class="signin-button button secondary">
                        <span>${text('signInPage.mobile.sendCode')}</span>
                    </button>
                </div>
            </div>
        `);

        let numberInput = new PhoneNumberInput({
            el: template.find('.mobileNumberContainer'),
            className: 'signInInput',
            id: 'mobileNumber',
            label: text('signInPage.mobile.mobileNumber'),
            type: 'tel',
            allowAllCountries: !this.idcOptions.primary.phoneCountryCodes,
            allowedCountries: this.idcOptions.primary.phoneCountryCodes
        }).render();

        this.inputContainer.append(template);
        this._addSecondarySignIn('libraryCard');

        this._updateGetOneInstantlyButton(false);

        this.el.focus();

        template.find('.signin-button').on('click', () => {
            this._sendCode(numberInput);
        });

        template.find('.signInInput input').on('keypress', this._getMobileNumberKeypressHandler(numberInput));
    }

    _addSecondarySignIn(type) {
        this.bottomSignInOptionsDiv.empty();

        let mainTemplate = $(`
            <div class="signInWith">${text('signInPage.or')}</div>
            <div class="OptionsContainer buttonsContainer">
                <button class="optionButton button">
                   ${type === 'mobileNumber' ? `
                        <img class="optionImage" alt='${ text('signInPage.mobile.usingMobileNumber') }' src='${ window.OverDrive.cdn }/public/img/phone-icon.svg'/>
                         <p>${text('signInPage.mobile.usingMobileNumber')}</p>
                    ` : `
                        <img class="optionImage" alt='${ text('signInPage.libraryCard.card') }' src='${ window.OverDrive.cdn }/public/img/library-card-icon.svg'/>
                        <p>${text('signInPage.libraryCard.card')}</p>
                    `}
                </button>
            </div>
        `);

        this.bottomSignInOptionsDiv.append(mainTemplate);

        this.bottomSignInOptionsDiv.find('.optionButton').click(() => {
            if (type === 'mobileNumber') {
                this._renderMobileNumberForm();
            } else {
                this._renderLibraryCardForm();
            }
        });
    }

    _updateGetOneInstantlyButton(isDefault) {
        let container = $('.getACardPromoHeader');
        let label = container.find('p');
        let button = container.find('.getOneInstantly');

        if (isDefault) {
            label.html(text('signInPage.memberYet'));
            button.html(`<span>${text('signInPage.getACardButton')}</span>`);

            $('.getOneInstantly').on('click', () => {
                this._renderIdcSignup();
            });
        }

        else {
            label.html(text('signInPage.alreadyMember'));
            button.html(`<span>${text('signIn')}</span>`);

            button.on('click', () => {
                this._render();
            });
        }
    }

    _renderVerificationCodeInput(phoneNumber, idcResponse) {
        this.el.empty();

        let template = $(`
            <div class="VerificationCodeContainer">
                <h1 class="verifyHeaderText primary-color">${text('signInPage.verifyYourNumber')}</h1>
                <p class="verifySubHeading">${text('signInPage.enterTheCode', {location: phoneNumber})}</p>
                <div class="verificationInputContainer inputContainer"></div>
                <p class="noCode">${text('signInPage.noCodeHtml', {resend: `<a tabindex="0" role="button" class="resendNow secondary-color">${text('signInPage.resendNow')}</a>`})}</p>
                <p>${text('signInPage.mobile.ratesMayApply')}</p>
                 <button class="signin-button button secondary" style="width: 96%">
                    <span>${text('signInPage.verify')}</span>
                </button>
            </div>
        `);

        let codeInput = new VerificationCodeInput({
            el: template.find('.verificationInputContainer'),
            className: 'verificationCode',
            id: 'verificationCode',
            label: text("signInPage.enterTheCode", {location: phoneNumber})
        }).render();

        this.el.append(template);
        codeInput.focus();

        template.find('.resendNow').on('click', () => {
            this._resendCode(phoneNumber);
        });

        template.find('.signin-button').on('click', () => {
            this._verifyCode(codeInput, idcResponse);
        });

        template.find('.verificationCode input').on('keypress', (e) => {
            if (e.which === 13) {
                e.preventDefault();
                this._verifyCode(codeInput, idcResponse);
            }
        });
    }

    _renderEmailVerificationCodeInput(email, idcResponse, ilsName) {
        this.el.empty();

        let template = $(`
            <div class="VerificationCodeContainer">
                <h1 class="verifyHeaderText primary-color">${text('signInPage.verifyYourEmail')}</h1>
                <p class="verifySubHeading">${text('signInPage.enterTheCode', {location: email})}</p>
                <div class="verificationInputContainer inputContainer"></div>
                <p class="noCode">${text('signInPage.noCodeHtml', {resend: `<a tabindex="0" role="button" class="resendNow secondary-color">${text('signInPage.resendNow')}</a>`})}</p>
                 <button class="signin-button button secondary" style="width: 96%">
                    <span>${text('signInPage.verify')}</span>
                </button>
            </div>
        `);

        let codeInput = new VerificationCodeInput({
            el: template.find('.verificationInputContainer'),
            className: 'verificationCode',
            id: 'verificationCode',
            label: text("signInPage.enterTheCode", {location: email})
        }).render();

        this.el.append(template);
        codeInput.focus();

        template.find('.resendNow').on('click', () => {
            this._resendEmailCode(email, ilsName);
        });

        template.find('.signin-button').on('click', () => {
            this._emailVerifyCode(codeInput, idcResponse, ilsName);
        });

        template.find('.verificationCode input').on('keypress', (e) => {
            if (e.which === 13) {
                e.preventDefault();
                this._emailVerifyCode(codeInput, idcResponse, ilsName);
            }
        });
    }

    _getMobileNumberKeypressHandler(mobileNumberInput){
        if (!mobileNumberInput) {
            throw new Error('you must pass "mobileNumberInput"');

        }
        return (e) => {
            if (e.which === 13) {
                e.preventDefault();
                this._sendCode(mobileNumberInput);
            }
        };
    }

    _renderIdcSignup() {
        this.el.empty();

        let template = $(`
            <div class="IdcSignupContainer">
                <h1 class="IdcHeaderText primary-color">${text('getCard.noLibraryCard')}</h1>
                <h1 class="IdcHeaderText2 primary-color">${text('getCard.noProblem')}</h1>
                <p class="IdcSubHeading">${text('getCard.takesAFewSec')}</p>
                <a class="whyDoYouNeed secondary-color" role="button" tabindex="0">${text('getCard.whyDoYouNeed')}</a>
                <p class="alreadyHaveCardHtml">${text('signInPage.idc.alreadyHaveCardHtml')}</p>
                <div class="IdcInputContainer inputContainer">
                    <div class="mobileNumberContainer"></div>
                    <div class="verificationCodeText">
                        <p>${text('signInPage.mobile.textVerificationCode')}</p>
                        <p>${text('signInPage.mobile.ratesMayApply')}</p>
                    </div>
                    <div class="buttonsContainer">
                        <button class="signin-button button secondary">
                            <span>${text('signInPage.mobile.sendCode')}</span>
                        </button>
                    </div>
                </div>
            </div>
        `);

        let numberInput = new PhoneNumberInput({
            el: template.find('.mobileNumberContainer'),
            className: 'signInInput',
            id: 'mobileNumber',
            label: text('signInPage.mobile.mobileNumber'),
            type: 'tel',
            allowAllCountries: !this.idcOptions.primary.phoneCountryCodes,
            allowedCountries: this.idcOptions.primary.phoneCountryCodes
        }).render();

        new NeedMoblieNumberPopover(template.find('.whyDoYouNeed')).render();

        this.el.append(template);

        this._updateGetOneInstantlyButton(false);

        this.el.focus();

        template.find('.signin-button').on('click', () => {
            this._sendCode(numberInput);
        });

        template.find('.signInInput input').on('keypress', this._getMobileNumberKeypressHandler(numberInput));
    }

    _renderIdcAdditionalInfo(idcResponse) {
        this.el.empty();

        let signUpOptions = idcResponse.signUpOptions[0];
        let requiredFields = signUpOptions.requiredFields.filter((field) => field !== 'PhoneToken' && field !== 'IpAddress');
        let optionalFields = signUpOptions.optionalFields;

        let fields = $('<div></div>');

        requiredFields.forEach((field) => {
           fields.append(`<div class="${field}Container"></div>`);
        });

        optionalFields.forEach((field) => {
            fields.append(`<div class="${field}Container"></div>`);
        });

        let terms = `<a href="https://company.cdn.overdrive.com/policies/terms-and-conditions.htm" class="secondary-color" target="_blank">${text('signInPage.idc.termsAndConditions')}</a>`;
        let policy = `<a href="https://company.cdn.overdrive.com/policies/privacy-policy.htm" class="secondary-color" target="_blank">${text('signInPage.idc.privacyPolicy')}</a>`;

        let template = $(`
            <div class="IdcAdditonalInfoContainer">
                <h1 class="IdcAdditionalHeaderText primary-color">${text('signInPage.idc.completeVerification')}</h1>
                 <p class="IdcAdditionalSubHeading">${text('signInPage.idc.fewMoreThings')}</p>
                 <div class="inputContainer">
                    ${fields.html()}
                 </div>
                 <p class="bySelectingContinue">${text('signInPage.idc.bySelectingContinue')}</p>
                 <ul>
                    <li>${text('signInPage.idc.13OrOlder')}</li>
                    <li>${text('signInPage.idc.youAgreeHtml', {terms, policy})}</li>
                </ul>
                <div class="buttonsContainer">
                    <button class="signin-button button secondary">
                        <span>${text('signInPage.idc.continue')}</span>
                    </button>
                </div>
                <div class="weRespectPrivacyContainer">
                    <img class="privacyIcon" alt='${ text('signInPage.idc.weRespectPrivacy') }' src='${ window.OverDrive.cdn }/public/img/privacy-icon.svg'/>
                    <p class="weRespectPrivacy">${text('signInPage.idc.weRespectPrivacy')}</p>
                </div>
            </div>
        `);

        let requiredFieldInputs = [];
        requiredFields.forEach((field) => {
            requiredFieldInputs.push(new FloatingLabelInput({
                el: template.find(`.${field}Container`),
                className: 'signInInput requiredField',
                id: field,
                label: text('signInPage.idc.' + field),
                type: 'text'
            }).render());
        });

        let optionalFieldInputs = [];
        optionalFields.forEach((field) => {
            optionalFieldInputs.push(new FloatingLabelInput({
                el: template.find(`.${field}Container`),
                className: 'signInInput',
                id: field,
                label: text('signInPage.optionalField', {fieldName :text('signInPage.idc.' + field)}),
                type: 'text'
            }).render());
        });

        this.el.append(template);
        this.el.focus();

        template.find('.signin-button').on('click', () => {
            this._signUp(requiredFieldInputs, optionalFieldInputs, idcResponse);
        });

        template.find('.signInInput input').on('keypress', (e) => {
            if (e.which === 13) {
                e.preventDefault();
                this._signUp(requiredFieldInputs, optionalFieldInputs, idcResponse);
            }
        });
    }

    _renderIdcDenied() {
        this.el.empty();

        let template = $(`
            <div class="IdcAdditonalInfoContainer">
                <h1 class="IdcAdditionalHeaderText primary-color">${text('signInPage.idc.unableToConfirm')}</h1>
                 <p class="weCouldntGrant">${text('signInPage.idc.weCouldntGrant')}</p>
                 <p class="youMayBeEligible">${text('signInPage.idc.youMayBeEligible')}
                    ${!!window.OverDrive.cardSignUpLink ? `
                        <a href="${window.OverDrive.cardSignUpLink}" class="secondary-color"  target="_blank">${text('signInPage.idc.learnMore')}</a>
                    ` : ''}
                </p>
                <div class="buttonsContainer">
                    <button class="signin-button button secondary">
                        <span>${text('signInPage.idc.goBack')}</span>
                    </button>
                </div>
            </div>
        `);

        this.el.append(template);
        this.el.focus();

        template.find('.signin-button').on('click', () => {
            this._render();
        });
    }

    _renderEmailRegistration(selectedForm, container) {
        this.el.find('.errorMessage').remove();

        let template = $(`
            <div class="EmailSignIn">
                <div class="emailContainer"></div>
                <div class="verificationCodeText">
                    <p>${text('signInPage.emailVerificationCode')}</p>
                </div>
                <div class="buttonsContainer">
                    <button class="signin-button button secondary">
                        <span>${text('signInPage.mobile.sendCode')}</span>
                    </button>
                </div>
            </div>
        `);

        let emailInput = new FloatingLabelInput({
            el: template.find('.emailContainer'),
            className: 'signInInput',
            id: 'email',
            label: text('signInPage.idc.Email'),
            type: 'text'
        }).render();

        container.append(template);
        if (this.ozoneData.forms.length > 1){
            this._addSecondarySignIn('libraryCard');
        }


        this.el.focus();

        template.find('.signin-button').on('click', () => {
            this._checkValidEmail(emailInput, selectedForm.ilsName);
        });

        template.find('.signInInput input').on('keypress', (e) => {
            if (e.which === 13) {
                e.preventDefault();
                this._checkValidEmail(emailInput, selectedForm.ilsName);
            }
        });
    }

    _signUp(requiredFieldInputs, optionalFieldInputs, idcResponse) {
        let valid = true;
        requiredFieldInputs.forEach((input) => {
            if (!input.validateNonEmpty()) {
                valid = false;
            }
        });

        if (valid) {
            this.el.find(".signin-button").empty().addClass('waiting').append('<div class="spinner"></div>');

            let userData = {};
            requiredFieldInputs.forEach((input) => {
               userData[input.$input.attr('id')] = input.$input.val();
            });

            optionalFieldInputs.forEach((input) => {
               userData[input.$input.attr('id')] = input.$input.val();
            });

            userData.PhoneToken = idcResponse.token;

            $.post(window.url(window.routes.rest.idc.signUp), {
                userData: JSON.stringify(userData),
                ilsName: this.ozoneData.getACard.primary.ilsName
            }).done((response) => {
                let successModal = new SignUpSuccessModal();
                window.globalEvents.trigger('signIn:mobileNum', window.OverDrive.libraryName);
                successModal.on('close', () => {
                    this._idcSignIn(response);
                });
            }).fail((err) => {
                this.el.find(".signin-button").empty().removeClass('waiting').append(text('signInPage.mobile.sendCode'));

                if (err.responseJSON.error.statusCode && err.responseJSON.error.statusCode === 'Denied') {
                    Logger.log('error', 'IDC sign-up step, user was denied', {message: err.responseText});
                    this._renderIdcDenied();
                }
                else {
                    Logger.log('error', 'IDC sign-up step failed', {message: err.responseText});
                    this._showErrorMessage(text('signInPage.idc.signUpError', {link: `<a href="${window.OverDrive.cardSignUpLink}">${text("signInPage.idc.contactLibrary")}</a>`}));
                }
            });
        }
    }

    _sendCode(phoneNumberInput) {
        if (phoneNumberInput.validate()){
            this.el.find(".signin-button").empty().addClass('waiting').append('<div class="spinner"></div>');

            $.post(window.url(window.routes.rest.idc.phone.sendCode), {
                phoneNumber: phoneNumberInput.E164
            }).done((response) => {
                window.globalEvents.trigger('mobile:register:code:sent');
                window.globalEvents.trigger('mobile:code:sent', window.OverDrive.libraryName);
                this._renderVerificationCodeInput(phoneNumberInput.displayValue, response);
            }).fail((err) => {
                this.el.find(".signin-button").empty().removeClass('waiting').append(text('signInPage.mobile.sendCode'));
                Logger.log('error', 'Send IDC code to phone failed', {message: err.responseText});
                this._showErrorMessage(text('signInPage.idc.errorSendingCode'));
            });
        }
    }

    _resendCode(phoneNumber) {
        $.post(window.url(window.routes.rest.idc.phone.sendCode), {
            phoneNumber
        }).done((response) => {
            window.globalEvents.trigger('mobile:code:resent', window.OverDrive.libraryName);
            window.globalEvents.trigger('mobile:register:code:resent');
            this._showCodeResentMessage();
        }).fail((err) => {
            Logger.log('error', 'Send IDC code to phone failed', {message: err.responseText});
            this._showErrorMessage(text('signInPage.idc.errorSendingCode'));
        });
    }

    _verifyCode(codeInput, idcResponse) {
        if (codeInput.validate()) {
            window.globalEvents.trigger('mobile:code:verified', window.OverDrive.libraryName);
            window.globalEvents.trigger('mobile:register:code:verified');
            this.el.find(".signin-button").empty().addClass('waiting').append('<div class="spinner"></div>');
            $.post(window.url(window.routes.rest.idc.phone.verifyCode), {
                code: codeInput.$input.val(),
                phoneE164: idcResponse.phoneE164,
                ilsName: this.ozoneData.getACard.primary.ilsName
            }).done((response) => {
                if (response.status === 'SignInAvailable') {
                    window.globalEvents.trigger('mobile:register:submit');
                    this._idcSignIn(response);
                } else if (response.status === 'SignUpAvailable') {
                    this._renderIdcAdditionalInfo(response);
                } else {
                    console.log(response);
                }
            }).fail((err) => {
                this.el.find(".signin-button").empty().removeClass('waiting').append(text('signInPage.mobile.sendCode'));
                Logger.log('error', 'Failed to verify IDC code', {message: err.responseText});
                this._showErrorMessage(text('signInPage.idc.errorSendingCode'));
            });
        }
    }

    _checkValidEmail(emailInput, ilsName) {
        if (emailInput.validateNonEmpty()) {
            this.el.find(".signin-button").empty().addClass('waiting').append('<div class="spinner"></div>');

            let userData = {
                Email: emailInput.$input.val()
            };

            $.post(window.url(window.routes.rest.idc.signUp), {
                userData: JSON.stringify(userData),
                ilsName
            }).done((response) => {
                window.globalEvents.trigger('signIn.email', ilsName);
                this._idcSignIn(response);
            }).fail((err) => {
                this.el.find(".signin-button").empty().removeClass('waiting').append(text('signInPage.mobile.sendCode'));

                if (err.responseJSON.error.statusCode && err.responseJSON.error.statusCode === 'Denied') {
                    Logger.log('error', 'IDC email was not valid', {message: err.responseText});
                    this._showErrorMessage(text('signInPage.emailIneligible'));
                }
                else if (err.responseJSON.error.requiredFields && err.responseJSON.error.requiredFields.includes('EmailToken')) {
                    this._emailSendCode(emailInput, ilsName);
                }
                else {
                    Logger.log('error', 'IDC check valid email step failed', {message: err.responseText});
                    this._showErrorMessage(text('signInPage.email.validationError'));
                }
            });
        }
    }

    _emailSignUp(ilsName, idcResponse) {
        this.el.find(".signin-button").empty().addClass('waiting').append('<div class="spinner"></div>');

        let userData = {
            Email: idcResponse.email,
            EmailToken: idcResponse.emailToken
        };

        $.post(window.url(window.routes.rest.idc.signUp), {
            userData: JSON.stringify(userData),
            ilsName
        }).done((response) => {
            this._idcSignIn(response);
        }).fail((err) => {
            this.el.find(".signin-button").empty().removeClass('waiting').append(text('signInPage.mobile.sendCode'));
            Logger.log('error', 'IDC email sign-up failed', {message: err.responseText});
            this._showErrorMessage(text('signInPage.idc.signUpError', {link: `<a href="${window.OverDrive.cardSignUpLink}">${text("signInPage.idc.contactLibrary")}</a>`}));
        });
    }

    _emailSendCode(emailInput, ilsName) {
        $.post(window.url(window.routes.rest.idc.email.sendCode), {
            emailAddress: emailInput.$input.val()
        }).done((response) => {
            window.globalEvents.trigger('email:code:sent', ilsName);
            this._renderEmailVerificationCodeInput(emailInput.$input.val(), response, ilsName);
        }).fail((err) => {
            this.el.find(".signin-button").empty().removeClass('waiting').append(text('signInPage.mobile.sendCode'));
            Logger.log('error', 'Send IDC code to email failed', {message: err.responseText});
            this._showErrorMessage(text('signInPage.idc.errorSendingCode'));
        });
    }

    _resendEmailCode(emailAddress) {
        $.post(window.url(window.routes.rest.idc.email.sendCode), {
            emailAddress
        }).done((response) => {
            window.globalEvents.trigger('email:code:resent', window.OverDrive.libraryName);
            this._showCodeResentMessage();
        }).fail((err) => {
            Logger.log('error', 'Send IDC code to email failed', {message: err.responseText});
            this._showErrorMessage(text('signInPage.idc.errorSendingCode'));
        });
    }

    _emailVerifyCode(codeInput, idcResponse, ilsName) {
        if (codeInput.validate()) {
            window.globalEvents.trigger('email:code:verified', ilsName);
            this.el.find(".signin-button").empty().addClass('waiting').append('<div class="spinner"></div>');
            $.post(window.url(window.routes.rest.idc.email.verifyCode), {
                code: codeInput.$input.val(),
                emailAddress: idcResponse.email,
                ilsName
            }).done((response) => {
                this._emailSignUp(ilsName, response);
            }).fail((err) => {
                this.el.find(".signin-button").empty().removeClass('waiting').append(text('signInPage.mobile.sendCode'));
                Logger.log('error', 'Failed to verify IDC email code', {message: err.responseText});
                this._showErrorMessage(text('signInPage.idc.invalidVerify'));
            });
        }
    }

    _idcSignIn(idcResponse) {
        const $form =  $(`
            <form method="post" action="${url(routes.ozone.authenticate, {forwardUrl: this.forwardUrl})}">
                <input type="hidden" name="authType" value="local">
                <input type="hidden" name="ilsName" value="${idcResponse.signIn.ilsName}">
                <input type="hidden" name="username" value="${idcResponse.signIn.username}">
                <input type="hidden" name="password" value="${idcResponse.signIn.password}">
            </form>
        `);

        this.el.append($form);

        $form.submit();
    }

    _showErrorMessage(message) {
        let template = $(`
            <div class="errorMessage">
                <div class="errorIcon">!</div>
                <p>${message}</p>
            </div>
        `);

        this.el.find('.errorMessage').remove();
        this.el.find('.inputContainer').before(template);
    }

    _showCodeResentMessage() {
        let template = $(`
            <div class="codeResent">
                <p> ${ text("signInPage.idc.newCodeSent") }
                    <span class="js-saved Saved-container">
                        <span class="Saved">
                            <svg class="Saved-Checkmark" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 52 52">
                                <circle class="Saved-checkmarkCircle" cx="26" cy="26" r="25" fill="none"></circle>
                                <path class="Saved-checkmarkCheck" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"></path>
                            </svg>
                        </span>
                    </span>
                </p>
            </div>
        `);
        this.el.find('.errorMessage').remove();
        this.el.find('.codeResent').remove();
        this.el.find('.inputContainer').before(template);
    }
}
